import React from 'react'
import './Notification.css'
import { Box, Typography } from '@mui/material'
import { Launch } from '@mui/icons-material'
import { INotificationReducer } from '../interface'
import ReactGA from 'react-ga4'

interface INotificationProps {
  data: INotificationReducer
}

export default function Notification(props: INotificationProps) {
  const { data } = props

  return (
    <Box data-gtm-click-section='Notification' data-gtm-click-subsection1={data.text}>
      <div
        data-gtm-click-subsection2='primary-cta'
        className='notification'
        style={{
          backgroundSize: 'cover',
          marginTop: 0,
          backgroundColor: data.backgroundColor,
          cursor: data.url ? 'pointer' : 'default'
        }}
        onClick={() => {
          data.url && window.open(data.url)
          ReactGA.gtag('event', 'notification_click')
        }}
      >
        <div className='booth-container'>
          <div className={data.url ? 'booth-text' : 'booth-no-button'}>
            <Typography variant='body1' style={{ color: data.textColor }}>
              {data.text}
            </Typography>
          </div>
          {data.url && <Launch style={{ color: data.textColor }} />}
        </div>
      </div>
    </Box>
  )
}
